import {Action} from '@reduxjs/toolkit';
import {appLocalStorage, appSessionStorage} from '~/shared/persistence';
import {onlyLeading} from '~/shared/utils/for-redux';
import {AddressStatus} from '../AddressStatus';
import {userinfoRoutine} from './userinfoActions';

async function userDetailsRequestEffect(_: Action, api: AppEffectAPI) {
    try {
        const json = await api.extra.fetchUserInfo();

        appSessionStorage.authStatus.set(json.status);
        appSessionStorage.uuid.set(json.uuid);
        appLocalStorage.authStatus.set(json.status);
        if (json.dossier?.personal.givenName) {
            appLocalStorage.givenName.set(json.dossier.personal.givenName);
        }

        api.dispatch(
            userinfoRoutine.success({
                userStatus: json.status,
                addressStatus: AddressStatus.toLegacy(json.dossier?.address.verifiedStatus),
            })
        );
    } catch (error) {
        // need to dispatch failure or listener in initDataRefreshEffect won't reload
        api.dispatch(userinfoRoutine.failure(error));
        throw error;
    }
}

export function initUserinfoEffects(startListening: AppStartListening) {
    startListening({actionCreator: userinfoRoutine.trigger, effect: onlyLeading(userDetailsRequestEffect)});
}
